/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./cell-region.component";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "@ngrx/store";
import * as i4 from "../../../services/event.service";
import * as i5 from "../../../services/action.service";
var styles_CellRegion = [""];
var RenderType_CellRegion = i0.ɵcrt({ encapsulation: 0, styles: styles_CellRegion, data: {} });
export { RenderType_CellRegion as RenderType_CellRegion };
export function View_CellRegion_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_CellRegion_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-cell-region", [], null, null, null, View_CellRegion_0, RenderType_CellRegion)), i0.ɵdid(1, 245760, null, 0, i1.CellRegion, [i2.NavController, i3.Store, i4.UIEventHub, i5.ActionCreator, i0.Injector], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CellRegionNgFactory = i0.ɵccf("app-cell-region", i1.CellRegion, View_CellRegion_Host_0, { id: "id", title: "title", childrenKeys: "childrenKeys", targetRegion: "targetRegion" }, {}, []);
export { CellRegionNgFactory as CellRegionNgFactory };
//# sourceMappingURL=cell-region.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/widgets/spread_sheet/cell-region/cell-region.component.ngfactory.js
// module id = 962
// module chunks = 1